<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="font-weight-medium text-h6">
      Dados do Agendamento
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <agendamento-form
        :ticket-id="ticketId"
        :solicitante-primeiro-endereco-cadastrado="solicitantePrimeiroEnderecoCadastrado"
        :agendamento-selecionado="agendamentoSelecionado"
        @refetch-data="$emit('refetch-data')"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import AgendamentoForm from './AgendamentoForm.vue'

export default {
  emits: ['refetch-data'],

  components: {
    AgendamentoForm,
  },

  props: {
    ticketId: {
      type: Number,
      required: true,
    },
    solicitantePrimeiroEnderecoCadastrado: {
      type: Object,
      default: null,
    },
    agendamentoSelecionado: {
      type: Object,
      default: null,
    },
  },
}
</script>
